import type { EmojiItem } from './types';

export const inputEmojiRegex = /:([a-zA-Z0-9_+-]+):$/;
export const pasteEmojiRegex = /:([a-zA-Z0-9_+-]+):/g;

export const isEmojiSupported = (emoji: EmojiItem['emoji']) => {
	return Boolean(emoji !== undefined);
};

export const shortcodeToEmoji = (shortcode: string, emojis: EmojiItem[]) =>
	emojis.find(
		(e) => e.name === shortcode || e.shortcodes.includes(shortcode)
	);
